import TablePagination from '@mui/material/TablePagination'
import React, { useEffect, useState } from 'react'
import Table from './TableMui';
const SelectTablePagination = ({view,payload,currentTableName}) => {
    const [tablesObject,setTablesObject]=useState<any>({})

    const handleChangePage = (event: unknown, newPage: number) => {
        setTablesObject(prev=>{
          let newTable={...prev}
          newTable[currentTableName].page=newPage
          return newTable
        })
      };
    
      const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTablesObject(prev=>{
          let newTable={...prev}
          newTable[currentTableName].page=0
          newTable[currentTableName].rowsPerPage=+event.target.value
          return newTable
        })
      };

      useEffect(()=>{
        setTablesObject(prev=>{
          let newTable={...prev}
          payload.forEach((t)=>{
            if(!tablesObject.hasOwnProperty(t.layerName)||(tablesObject.hasOwnProperty(t.layerName)&&t.features.length!==newTable[t.layerName].count)){
            newTable[t.layerName]={
              page:0,
              rowsPerPage:10,
              count:t.features.length
            }
          }
          })
          return newTable
        })
      },[payload])

      const tables=   payload.map((table=>{
        return (
         <React.Fragment key={table?.layerName}>
          {tablesObject.hasOwnProperty(table?.layerName)?
        <Table  view={view} table={table} activeWidget={currentTableName}
        page={tablesObject[table?.layerName].page}
        rowsPerPage={tablesObject[table?.layerName].rowsPerPage}  />
            :""}
  </React.Fragment>
        )
     }))

  return (
    <div>
      {payload.length>0?
      <>
      {tables}
      {tablesObject.hasOwnProperty(currentTableName)?
    <TablePagination key={`page-pagination`}

    style={{
      overflowX:'hidden',
        position: "absolute",
        bottom:0,
        width:'98%',
      }}
    rowsPerPageOptions={[10,25,100]}
    rowsPerPage={tablesObject[currentTableName].rowsPerPage}
    count={tablesObject[currentTableName].count}
    component="div"
    page={tablesObject[currentTableName].page}
    onPageChange={handleChangePage}
    onRowsPerPageChange={handleChangeRowsPerPage}
    />:""}
    </>
    :""}
    </div>
  )
}

export default SelectTablePagination